module.exports = __webpack_public_path__ + "img/11.d2974e11.jpg";